import { type ReactElement, type SyntheticEvent, forwardRef } from 'react';

import { type INavLinks, type TSectionAnchor } from 'shared/settings/routes';

import styles from './HeaderV2.css';

type HeaderV2Props = {
  callback?: ReactElement;
  isSticky: boolean;
  logo?: ReactElement;
  navLinks: INavLinks[];
  number?: ReactElement;
  onNavSectionClick: (section: TSectionAnchor, event: SyntheticEvent) => void;
};

export const HeaderV2 = forwardRef<HTMLElement, HeaderV2Props>(function HeaderV2(props, ref) {
  const { callback, isSticky, logo, navLinks, number, onNavSectionClick } = props;

  return (
    <header className={styles['menu']} data-sticky={isSticky} data-testid="main-carousel-v2-menu" ref={ref}>
      {logo && <div className={styles['logo']}>{logo}</div>}

      <nav
        aria-label="Навигация по странице"
        className={styles['navigation']}
        data-testid="main-carousel-v2-menu-links"
      >
        {navLinks.map(section => (
          <a
            className={styles['link']}
            data-testid={`main-carousel-v2-menu-item-${section.value}`}
            href={`#${section.value}`}
            key={section.value}
            onClick={event => onNavSectionClick(section.value, event)}
          >
            {section.title}
          </a>
        ))}
      </nav>

      <div className={styles['contacts']}>
        {number}
        {callback}
      </div>
    </header>
  );
});
